import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import AutoFormDialog from "../dialogTypes/AutoFormDialog";
import ActionButtonLayout from "../layout/ActionButtonLayout";

import { cloneDeep } from "lodash";

function TkInputInspectionInputButton(props) {

    const { t } = useTranslation();

    const { id, schema, grid, refresh, onSuccess, customizeErrorMsgCallback, ...others } = props;

    const [open, setOpen] = useState(false);
    const [formData, setFormData] = useState();
    const [tableSchema, setTableSchema] = useState();

    useEffect(() => {
        if (schema) {
            let newSchema = cloneDeep(schema)
            for (let column of newSchema.columns) {
                switch (column.name) {
                    case "inputInspectionContainerId":
                        column.hideInForm = false;
                        break;
                    case "inputManager":
                        break;
                    case "inputDate":
                        column.hideInForm = false;
                        break;
                    case "wareHouseCode":
                        column.hideInForm = false;
                        column.required = true;
                        break;
                    default:
                        column.readonly = true;
                        break;
                }
            }
            setTableSchema(newSchema)
        }
    }, [schema])

    const modifyUrlCallback = () => {
        return "/api/TkInputInspectionContainer/InputMaterial"
    }

    const onOpen = () => {

        if (grid) {

            setFormData({ ...(grid.selectedItems[0]), inputDate: new Date() });
            console.log(grid.selectedItems[0])
        }

        setOpen(true);

    };

    const onClose = () => {

        setOpen(false);

    };

    const onUpdateSuccess = (msg) => {

        if (onSuccess) {

            onSuccess(msg);

        }

        refresh.refresh();

    };

    return (

        <>
            <ActionButtonLayout onClick={onOpen} {...others}>{t("buttonName.input")}</ActionButtonLayout>
            <AutoFormDialog
                id={id + "update-dialog"}
                mode="edit"
                labels={[t("buttonName.materialInput")]}
                formId={id + "update-form"}
                title={t("buttonName.input")}
                schema={tableSchema}
                initialData={formData}
                open={open}
                onClose={onClose}
                onSuccess={onUpdateSuccess}
                modifyUrlCallback={modifyUrlCallback}
                customizeErrorMsgCallback={customizeErrorMsgCallback}
            />
        </>

    );
}

export default TkInputInspectionInputButton;

